export default __webpack_public_path__ + "static/media/194.70321905.png";